import DailyWeatherCard from '@components/WeatherPanel/components/DailyWeatherCard';
import useWeatherData from '@hooks/Weather/useWeatherData';
import { Card, Spin, Row, Col } from 'antd';
import './style.less';

const WeatherPanel = () => {
  const { data, loading } = useWeatherData();

  return (
    <Card className="weather-panel-container">
      <Spin spinning={loading}>
        <Row className="weather-panel-info" style={{ marginLeft: 0 }}>
          {data?.data.byDay.map((daily) => (
            <Col
              lg={{ span: 8 }}
              md={{ span: 8 }}
              sm={{ span: 12 }}
              xs={{ span: 12 }}
              key={daily.date_text}
            >
              <DailyWeatherCard data={daily} />
            </Col>
          ))}
        </Row>
      </Spin>
    </Card>
  );
};

export default WeatherPanel;
